const TRUNCATED_PLACEHOLDER = '[Truncated]';
const DEFAULT_MAX_FIELD_BYTES = 32 * 1024;

// Pure-JS UTF-8 byte size 計算,避免反覆 new Blob() 在主執行緒跨 V8/Browser
// binding 造成的成本(高頻 WS 事件下會擠壓 frame budget)。
// Surrogate pair 視為 4 bytes(U+10000 以上的 BMP 外字元)。
export const getStringByteSize = value => {
	if (typeof value !== 'string') {
		return 0;
	}

	let size = 0;

	for (let i = 0; i < value.length; i++) {
		const code = value.charCodeAt(i);

		if (code < 0x80) {
			size += 1;
		} else if (code < 0x800) {
			size += 2;
		} else if (code >= 0xD800 && code < 0xDC00) {
			size += 4;
			i++;
		} else {
			size += 3;
		}
	}

	return size;
};

// 將字串截斷到 maxBytes 以內,超出時尾端附加 ...[Truncated]。
// 單次線性掃描:邊計 byte 邊追蹤「最後一個 byte 累積仍 ≤ maxContentBytes」的
// char index;確保 UTF-8 多位元組與 UTF-16 surrogate pair 都不會被截在中間。
export const truncateStringField = (value, maxBytes = DEFAULT_MAX_FIELD_BYTES) => {
	if (typeof value !== 'string') {
		return value;
	}

	const suffix = `...${TRUNCATED_PLACEHOLDER}`;
	const suffixBytes = getStringByteSize(suffix);
	const maxContentBytes = maxBytes - suffixBytes;

	if (maxContentBytes <= 0) {
		return getStringByteSize(value) <= maxBytes ? value : TRUNCATED_PLACEHOLDER;
	}

	let totalBytes = 0;
	let safeBytes = 0;
	let safeCharIndex = 0;

	for (let i = 0; i < value.length; i++) {
		const code = value.charCodeAt(i);
		let charBytes;
		let isPair = false;

		if (code < 0x80) {
			charBytes = 1;
		} else if (code < 0x800) {
			charBytes = 2;
		} else if (code >= 0xD800 && code < 0xDC00) {
			charBytes = 4;
			isPair = true;
		} else {
			charBytes = 3;
		}

		totalBytes += charBytes;

		if (safeBytes + charBytes <= maxContentBytes) {
			safeBytes += charBytes;
			safeCharIndex = isPair ? i + 2 : i + 1;
		}

		if (isPair) {
			i++;
		}
	}

	if (totalBytes <= maxBytes) {
		return value;
	}

	return `${value.slice(0, safeCharIndex)}${suffix}`;
};
